import { REQUEST_STATUSES, SEARCH_OPTION_SECTION, SEARCH_OPTION_TYPE, VB_MODE } from "@/constants/index.js";

import * as types from "./types.js";
import {
  MediaItemService,
  PresentationService,
  PublicVisualizationService,
  VisualizationService,
} from "../../../services";
import { getVisualBuilderMode } from "../../../utils/visualBuilder";

export const getMediaItemSearchOptions = (params) => {
  return async (dispatch) => {
    const { propertyId } = params;
    const key = `${SEARCH_OPTION_SECTION.MEDIA_ITEM}/${propertyId}`;
    dispatch({
      type: types.SET_SEARCH_OPTIONS_REQUEST_STATUS,
      payload: { key, status: REQUEST_STATUSES.LOADING },
    });

    const searchOptions = [];

    const { resp, status, err } = await MediaItemService.getSearchOptions(propertyId);

    const { searchableContentTypes = [], searchableTags = [], searchableMembers = [] } = resp;

    if (searchableContentTypes.length || searchableTags.length || searchableMembers.length) {
      searchableContentTypes.forEach((contentType) =>
        searchOptions.push({
          name: contentType.name,
          value: contentType.id,
          type: SEARCH_OPTION_TYPE.TYPE,
          icon: contentType.value,
        }),
      );
      searchableTags.forEach((tag) =>
        searchOptions.push({
          name: tag.name,
          value: tag.id,
          type: SEARCH_OPTION_TYPE.TAG,
          icon: "tag",
        }),
      );
      searchableMembers.forEach((member) =>
        searchOptions.push({
          name: member.user.name,
          value: member.id,
          type: SEARCH_OPTION_TYPE.MEMBER,
          icon: "user",
        }),
      );
    }

    dispatch({
      type: types.SET_SEARCH_OPTIONS,
      payload: { key, searchOptions, status, err },
    });
  };
};

export const getVisualBuilderSearchOptions = (params) => {
  return async (dispatch) => {
    const { key: vbKey, mode } = getVisualBuilderMode(params);
    const key = `${mode}/${vbKey}`;
    dispatch({
      type: types.SET_SEARCH_OPTIONS_REQUEST_STATUS,
      payload: { key, status: REQUEST_STATUSES.LOADING },
    });

    const { propertyId, experienceId } = params;
    const payload = { key, searchOptions: [] };

    if (mode === VB_MODE.PRESENTATION) {
      const { resp, status, err } = await PresentationService.getSearchOptions(propertyId);
      payload.resp = resp;
      payload.status = status;
      payload.err = err;
    }

    if (mode === VB_MODE.VISUALIZATION) {
      const { resp, status, err } = await VisualizationService.getSearchOptions(propertyId, experienceId);
      payload.resp = resp;
      payload.status = status;
      payload.err = err;
    }

    if (
      [
        VB_MODE.PUBLIC_VISUALIZATION,
        VB_MODE.PUBLIC_MEDIA_SHARE_VISUALIZATION,
        VB_MODE.PUBLIC_SINGLE_SHARE_VISUALIZATION,
      ].includes(mode)
    ) {
      const { resp, status, err } = await PublicVisualizationService.getSearchOptions(propertyId, experienceId);
      payload.resp = resp;
      payload.status = status;
      payload.err = err;
    }

    const { searchableContentTypes = [], searchableTags = [] } = payload.resp;

    if (searchableContentTypes.length || searchableTags.length) {
      searchableContentTypes.forEach((contentType) =>
        payload.searchOptions.push({
          name: contentType.name,
          value: contentType.id,
          type: SEARCH_OPTION_TYPE.TYPE,
          icon: contentType.value,
        }),
      );
      searchableTags.forEach((tag) =>
        payload.searchOptions.push({
          name: tag.name,
          value: tag.id,
          type: SEARCH_OPTION_TYPE.TAG,
          icon: "tag",
        }),
      );
    }

    delete payload.resp;

    dispatch({
      type: types.SET_SEARCH_OPTIONS,
      payload,
    });
  };
};
